import { Button, Result, Typography } from 'antd';
import React from 'react';

function Transfer({ href }) {
  return (
    <Result
      title="파일 다운로드 안내"
      subTitle={
        <Typography.Paragraph>
          Cloud에 저장된 파일을 Local PC로 이동하는 기능입니다.
        </Typography.Paragraph>
      }
      extra={
        <Button type="primary" key="console" href={href} target="_blank">
          {href}
        </Button>
      }
    >
      <ol style={{ marginBottom: 0 }}>
        <li>Cloud에서 Let’s &gt; 신청서 &gt; 파일 다운로드 신청서 작성 후 승인이 완료된 후</li>
        <li>
          아래 Site에 로그인하여 My Cloud &gt; 다운로드 사용현황 메뉴에서 파일을 다운로드 할 수
          있습니다.
        </li>
      </ol>
    </Result>
  );
}

export default Transfer;
